import React from "react";
import { Info } from "lucide-react";

import { Alert, AlertDescription } from "@/components/ui/alert";
import { REPORT_FINDINGS_DISCLAIMER } from "../../utils/reportFindings";

const REPORT_FINDINGS_ALERT_CLASS =
  "mt-2 mb-3 rounded-lg font-[family-name:var(--font-primary)]";

const REPORT_FINDINGS_ALERT_DESC_CLASS =
  "font-[family-name:var(--font-primary)] text-sm font-normal leading-5 text-muted-foreground";

export function ReportFindingsDisclaimerBox(): React.ReactElement {
  return (
    <Alert
      data-report-findings-disclaimer=""
      variant="info"
      className={REPORT_FINDINGS_ALERT_CLASS}
    >
      <Info aria-hidden />
      <AlertDescription className={REPORT_FINDINGS_ALERT_DESC_CLASS}>
        {REPORT_FINDINGS_DISCLAIMER}
      </AlertDescription>
    </Alert>
  );
}
